import React from "react";

// All icons use currentColor for production theming
export const PlusIcon = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" {...props}>
    <path fill="currentColor" d="M11 5a1 1 0 0 1 2 0v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6H5a1 1 0 1 1 0-2h6V5z" />
  </svg>
);

export const VideoIcon = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" {...props}>
    <path fill="currentColor" d="M3 6a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v2.382l4.553-2.276A1 1 0 0 1 20 7v10a1 1 0 0 1-1.447.894L14 15.618V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6zm2 0h7v12H5V6zM14 9.618 19 12l-5 2.382V9.618z" />
  </svg>
);

export const MicIcon = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" {...props}>
    <path fill="currentColor" d="M12 3a3 3 0 0 1 3 3v6a3 3 0 0 1-6 0V6a3 3 0 0 1 3-3Zm0 14a5 5 0 0 0 5-5 1 1 0 1 1 2 0 7 7 0 0 1-6 6.93V21a1 1 0 1 1-2 0v-2.07A7 7 0 0 1 5 12a1 1 0 1 1 2 0 5 5 0 0 0 5 5Z" />
  </svg>
);

export const CanvasIcon = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" {...props}>
    <path fill="currentColor" d="M5 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5Zm2 0h10v10H7V5Z" />
    <path fill="currentColor" d="M8 17h8a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2Z" />
  </svg>
);

export const SendIcon = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" {...props}>
    <path fill="currentColor" d="M2.01 3.555a1 1 0 0 1 1.18-.764l18 4a1 1 0 0 1 .144 1.918L14 11.764V18a1 1 0 0 1-1.707.707l-3-3A1 1 0 0 1 9 14v-2.236L3.19 7.81a1 1 0 0 1-.18-1.746L6.7 3.9l-3.51-.82a1 1 0 0 1-.18-.525ZM9 12.382V14.586l1.586 1.586L11 14v-2.236l7.606-2.435L4.8 6.4l4.2 1.013V8a1 1 0 0 1-.208.618L9 8.618v3.764Z" />
  </svg>
);

export const CaretDownIcon = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" {...props}>
    <path fill="currentColor" d="M6.293 9.293a1 1 0 0 1 1.414 0L12 13.586l4.293-4.293a1 1 0 1 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414Z" />
  </svg>
);

export const LinkIcon = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" {...props}>
    <path fill="currentColor" d="M10.59 13.41a1 1 0 0 1 0-1.41l2.83-2.83a3 3 0 1 1 4.24 4.24l-2 2a3 3 0 0 1-4.24 0 1 1 0 1 1 1.41-1.41 1 1 0 0 0 1.41 0l2-2a1 1 0 0 0-1.41-1.41l-2.83 2.83a1 1 0 0 1-1.41 0Z" />
    <path fill="currentColor" d="M8.83 15.17a3 3 0 0 1 0-4.24l2-2a3 3 0 0 1 4.24 0 1 1 0 1 1-1.41 1.41 1 1 0 0 0-1.41 0l-2 2a1 1 0 0 0 1.41 1.41l.71-.71a1 1 0 1 1 1.41 1.41l-.71.71a3 3 0 0 1-4.24 0Z" />
  </svg>
);

export const ListOrderedIcon = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" {...props}>
    <path fill="currentColor" d="M8 7a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z" />
    <path fill="currentColor" d="M4 6.25c.276 0 .5-.224.5-.5V4.5A.5.5 0 0 0 4 4a.5.5 0 0 0-.5.5V6H3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 .5-.5v-.25zM3.5 11.5H4a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1h.25L3 12.5a.5.5 0 1 0 1 0l-.5-1zM3.5 16.5H4a.5.5 0 1 0 0-1h-1a.5.5 0 0 0 0 1h.25L3 18.5a.5.5 0 1 0 1 0l-.5-2z" />
  </svg>
);

export const ListBulletIcon = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" {...props}>
    <path fill="currentColor" d="M9 6a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1Z" />
    <circle cx="5" cy="6" r="1.5" fill="currentColor" />
    <circle cx="5" cy="11" r="1.5" fill="currentColor" />
    <circle cx="5" cy="16" r="1.5" fill="currentColor" />
  </svg>
);

export const QuoteIcon = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" {...props}>
    <path fill="currentColor" d="M8 7H5a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h3v-6H6a1 1 0 0 1 0-2h2V7zm11 0h-3a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h3v-6h-2a1 1 0 0 1 0-2h2V7z" />
  </svg>
);

export const CodeIcon = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" {...props}>
    <path fill="currentColor" d="M9.172 7.757a1 1 0 0 1 0 1.414L6.343 12l2.829 2.829a1 1 0 1 1-1.414 1.414L3.515 12l4.243-4.243a1 1 0 0 1 1.414 0Zm5.656 0a1 1 0 0 1 1.414 0L20.485 12l-4.243 4.243a1 1 0 1 1-1.414-1.414L17.657 12l-2.829-2.829a1 1 0 0 1 0-1.414Z" />
  </svg>
);

// New small action icons for message actions panel
export const SmileIcon = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" {...props}>
    <path fill="currentColor" d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-3.5 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm7 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM12 18a5.5 5.5 0 0 1-4.712-2.6.9.9 0 1 1 1.424-1.1 3.7 3.7 0 0 0 6.576 0 .9.9 0 1 1 1.424 1.1A5.5 5.5 0 0 1 12 18Z" />
  </svg>
);

export const ReplyIcon = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" {...props}>
    <path fill="currentColor" d="M10 8V5.5a1 1 0 0 0-1.64-.768L2.6 9.232a1 1 0 0 0 0 1.536l5.76 4.5A1 1 0 0 0 10 14.5V12c5.523 0 9 2.239 10.5 6.5-.5-8-5.5-10.5-10.5-10.5Z" />
  </svg>
);

export const KebabIcon = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" {...props}>
    <circle cx="12" cy="5" r="1.6" fill="currentColor" />
    <circle cx="12" cy="12" r="1.6" fill="currentColor" />
    <circle cx="12" cy="19" r="1.6" fill="currentColor" />
  </svg>
);

const icons = {
  PlusIcon,
  VideoIcon,
  MicIcon,
  CanvasIcon,
  SendIcon,
  CaretDownIcon,
  LinkIcon,
  ListOrderedIcon,
  ListBulletIcon,
  QuoteIcon,
  CodeIcon,
  SmileIcon,
  ReplyIcon,
  KebabIcon,
};

export default icons;
